import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Box } from '@material-ui/core';
import AddBox from '@material-ui/icons/AddBox';
import ActiveAttributesModal from './ActiveAttributesModal';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.grey.light,
    boxShadow: `inset 0 -1px 0 ${theme.palette.grey.medium}`,
    '& td': {
      padding: 0,
      '&:not(last-child)': {
        borderRight: `1px solid ${theme.palette.grey.medium}`
      }
    }
  },
  addButton: {
    display: 'inline-flex',
    alignItems: 'center',
    height: theme.customStyles.addButton.height,
    padding: theme.customStyles.addButton.padding,
    verticalAlign: theme.customStyles.addButton.verticalAlign,
    userSelect: 'none',
    cursor: 'pointer',
    '& svg': {
      color: theme.palette.accent.main,
      marginRight: '.25rem',
      width: theme.customStyles.addAttributeSvg.width
    },
    '& span': {
      fontWeight: theme.typography.fontWeightBold,
      color: theme.palette.primary.main,
      fontSize: theme.customStyles.addAttributeSpan.fontSize
    }
  }
}));

const BottomToolbar = ({ attributes, dashboardData, onAttributesUpdateSubmit }) => {
  const [isAttributeModalOpen, setIsAttributeModalOpen] = useState(false);

  const classes = useStyles();

  const openAttributeModal = () => {
    setIsAttributeModalOpen(true);
  };

  const closeAttributeModal = () => {
    setIsAttributeModalOpen(false);
  };

  return (
    <Box component="div" className={classes.root}>
      <Box component="div" role="none" className={classes.addButton} onClick={openAttributeModal}>
        <AddBox />
        <Box component="span">Add Attribute</Box>
      </Box>

      {isAttributeModalOpen && (
        <ActiveAttributesModal
          attributes={attributes}
          dashboardData={dashboardData}
          isOpen={isAttributeModalOpen}
          onClose={closeAttributeModal}
          onAttributesUpdateSubmit={onAttributesUpdateSubmit}
        />
      )}
    </Box>
  );
};

BottomToolbar.propTypes = {
  attributes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  dashboardData: PropTypes.shape({}),
  onAttributesUpdateSubmit: PropTypes.func.isRequired
};

BottomToolbar.defaultProps = {
  dashboardData: {}
};

export default BottomToolbar;
